import { useQuery } from "react-query";
import { supabase } from "../../../supabaseClient";
import TaskTile from "./TaskTile";
import { Task } from "../models/Task";

export default function RelatedTasks({ task }: { task: Task }) {
  const { data, isLoading, error } = useQuery(
    ["related_tasks", task.id],
    async () => {
      return supabase.rpc("match_tasks", {
        query_embedding: task.embedding,
        match_threshold: 0.78, // Choose an appropriate threshold for your data
        match_count: 10, // Choose the number of matches
      });
    }
  );

  if(data?.data && data?.data.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="text-3xl font-bold mt-8 mb-4">Related Snippets</div>
      {data?.data && data?.data.length > 0 && (
        <div className="space-y-4 w-full">
          {data.data.map((task: Task) => (
            <TaskTile
              key={task.id}
              task={task}
            />
          ))}
        </div>
      )}
    </div>
  );
}
